import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { EmployeeLaw } from '../entities/employee-law';

@Injectable()
export class EmployeeLawService extends BaseCrudService<EmployeeLaw> {

  public uri = '/api/employeeLaw/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance EmployeeLawService');
  }

  addLogicToSearch(value: EmployeeLaw) {
    if (value.snpDeduction) {
      value.pensionRegime = value.snpDeduction.name;
    } else if (value.afp) {
      value.pensionRegime = value.afp.name;
    } else {
      value.pensionRegime = undefined;
    }
  }

  buildSentence(entity?: EmployeeLaw, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.row ?
          `row${QueryOperator.Contain}${entity.row}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isCurrent ?
          `isCurrent${QueryOperator.Equal}${entity.isCurrent}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.startDate ?
          `startDate${QueryOperator.Equal}${entity.startDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.endDate ?
          `endDate${QueryOperator.Equal}${entity.endDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.supportingDocumentNumber ?
          `supportingDocumentNumber${QueryOperator.Contain}${entity.supportingDocumentNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.supportingDocumentDate ?
          `supportingDocumentDate${QueryOperator.Equal}${entity.supportingDocumentDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.essaludNumber ?
          `essaludNumber${QueryOperator.Contain}${entity.essaludNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.afpNumber ?
          `afpNumber${QueryOperator.Contain}${entity.afpNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.pensionTtypeDate ?
          `pensionTtypeDate${QueryOperator.Equal}${entity.pensionTtypeDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.sctrPercentage ?
          `sctrPercentage${QueryOperator.Contain}${entity.sctrPercentage}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.hasEnsuredPension ?
          `hasEnsuredPension${QueryOperator.Equal}${entity.hasEnsuredPension}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.hasEps ?
          `hasEps${QueryOperator.Equal}${entity.hasEps}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.epsPlanDate ?
          `epsPlanDate${QueryOperator.Equal}${entity.epsPlanDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.epsRegisterNumber ?
          `epsRegisterNumber${QueryOperator.Contain}${entity.epsRegisterNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.hasExemption5ta ?
          `hasExemption5ta${QueryOperator.Equal}${entity.hasExemption5ta}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.previous5ta ?
          `previous5ta${QueryOperator.Contain}${entity.previous5ta}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.previousIncome ?
          `previousIncome${QueryOperator.Contain}${entity.previousIncome}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.hasVoluntary4ta ?
          `hasVoluntary4ta${QueryOperator.Equal}${entity.hasVoluntary4ta}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.hasEstablished4ta ?
          `hasEstablished4ta${QueryOperator.Equal}${entity.hasEstablished4ta}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.suspensionNumber4ta ?
          `suspensionNumber4ta${QueryOperator.Contain}${entity.suspensionNumber4ta}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.suspensionDate4ta ?
          `suspensionDate4ta${QueryOperator.Equal}${entity.suspensionDate4ta}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isResponsibleMotherFm ?
          `isResponsibleMotherFm${QueryOperator.Equal}${entity.isResponsibleMotherFm}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.hasEssaludVida ?
          `hasEssaludVida${QueryOperator.Equal}${entity.hasEssaludVida}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.employeeContract && entity.employeeContract.id) {
        query = query.concat(
          `employeeContract.id${QueryOperator.Equal}${entity.employeeContract.id}${QueryOperator.Split}`
        );
      }
      // if (entity.employeeContract && entity.employeeContract.terminationDate==null) {
      //   query = query.concat(
      //     `employeeContract.terminationDate${QueryOperator.IsNull}${entity.employeeContract.terminationDate}${QueryOperator.Split}`
      //   );
      // }
      // if (entity.employeeContract && entity.employeeContract.isCurrent) {
      //   query = query.concat(
      //     `employeeContract.isCurrent${QueryOperator.Equal}${entity.employeeContract.isCurrent}${QueryOperator.Split}`
      //   );
      // }
      if (entity.executingUnit && entity.executingUnit.id) {
        query = query.concat(
          `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
        );
      }
      if (entity.laborLaw && entity.laborLaw.id) {
        query = query.concat(
          `laborLaw.id${QueryOperator.Equal}${entity.laborLaw.id}${QueryOperator.Split}`
        );
      }
      if (entity.fiscalYear && entity.fiscalYear.id) {
        query = query.concat(
          `fiscalYear.id${QueryOperator.Equal}${entity.fiscalYear.id}${QueryOperator.Split}`
        );
      }
      if (entity.supportingDocument && entity.supportingDocument.id) {
        query = query.concat(
          `supportingDocument.id${QueryOperator.Equal}${entity.supportingDocument.id}${QueryOperator.Split}`
        );
      }
      if (entity.employerContribution && entity.employerContribution.id) {
        query = query.concat(
          `employerContribution.id${QueryOperator.Equal}${entity.employerContribution.id}${QueryOperator.Split}`
        );
      }
      if (entity.payScale && entity.payScale.id) {
        query = query.concat(
          `payScale.id${QueryOperator.Equal}${entity.payScale.id}${QueryOperator.Split}`
        );
      }
      if (entity.snpDeduction && entity.snpDeduction.id) {
        query = query.concat(
          `snpDeduction.id${QueryOperator.Equal}${entity.snpDeduction.id}${QueryOperator.Split}`
        );
      }
      if (entity.afp && entity.afp.id) {
        query = query.concat(
          `afp.id${QueryOperator.Equal}${entity.afp.id}${QueryOperator.Split}`
        );
      }
      if (entity.afpComission && entity.afpComission.id) {
        query = query.concat(
          `afpComission.id${QueryOperator.Equal}${entity.afpComission.id}${QueryOperator.Split}`
        );
      }
      if (entity.pensionTtype && entity.pensionTtype.id) {
        query = query.concat(
          `pensionTtype.id${QueryOperator.Equal}${entity.pensionTtype.id}${QueryOperator.Split}`
        );
      }
      if (entity.sctrPension && entity.sctrPension.id) {
        query = query.concat(
          `sctrPension.id${QueryOperator.Equal}${entity.sctrPension.id}${QueryOperator.Split}`
        );
      }
      if (entity.eps && entity.eps.id) {
        query = query.concat(
          `eps.id${QueryOperator.Equal}${entity.eps.id}${QueryOperator.Split}`
        );
      }
      if (entity.suspensionYear4ta && entity.suspensionYear4ta.id) {
        query = query.concat(
          `suspensionYear4ta.id${QueryOperator.Equal}${entity.suspensionYear4ta.id}${QueryOperator.Split}`
        );
      }
      if (entity.medicalInsuranceFm && entity.medicalInsuranceFm.id) {
        query = query.concat(
          `medicalInsuranceFm.id${QueryOperator.Equal}${entity.medicalInsuranceFm.id}${QueryOperator.Split}`
        );
      }
      if (entity.taxtreaty && entity.taxtreaty.id) {
        query = query.concat(
          `taxtreaty.id${QueryOperator.Equal}${entity.taxtreaty.id}${QueryOperator.Split}`
        );
      }
      if (entity.epsPlan && entity.epsPlan.id) {
        query = query.concat(
          `epsPlan.id${QueryOperator.Equal}${entity.epsPlan.id}${QueryOperator.Split}`
        );
      }
      if (entity.fdsa && entity.fdsa.id) {
        query = query.concat(
          `fdsa.id${QueryOperator.Equal}${entity.fdsa.id}${QueryOperator.Split}`
        );
      }
      if (entity.employmentRegime && entity.employmentRegime.id) {
        query = query.concat(
          `employmentRegime.id${QueryOperator.Equal}${entity.employmentRegime.id}${QueryOperator.Split}`
        );
      }
      if (entity.employmentRegimeType && entity.employmentRegimeType.id) {
        query = query.concat(
          `employmentRegimeType.id${QueryOperator.Equal}${entity.employmentRegimeType.id}${QueryOperator.Split}`
        );
      }
      if (entity.epsStatus && entity.epsStatus.id) {
        query = query.concat(
          `epsStatus.id${QueryOperator.Equal}${entity.epsStatus.id}${QueryOperator.Split}`
        );
      }
      if (entity.suspensionMeans4ta && entity.suspensionMeans4ta.id) {
        query = query.concat(
          `suspensionMeans4ta.id${QueryOperator.Equal}${entity.suspensionMeans4ta.id}${QueryOperator.Split}`
        );
      }
      if (entity.sctrInsurance && entity.sctrInsurance.id) {
        query = query.concat(
          `sctrInsurance.id${QueryOperator.Equal}${entity.sctrInsurance.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }

    this.httpParams = this.httpParams.set(QueryOperator.SortParam, 'row');
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/employee-law.service.ts